import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

const selectSelf = (s: RootState) => s.events;

export const isAllEventsLoadedSelector = createSelector(
  selectSelf,
  (s) => !!s.loadedEvents && s.loadedEvents === s.totalEvents,
);
